import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone } from "lucide-react";
import { api } from "../../lib/api";
import { VendorCard } from "./VendorCard";

// "Sponsored" strip of promoted vendor pages (weighted by daily budget) — used on the home page and couples' dashboard.
export function SponsoredVendors({ place = "home", limit = 4, title = "Featured wedding pros", dark = false }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/public/promoted-vendors", { params: { limit, place } }).then((r) => setRows(r.data.rows || [])).catch(() => {}); }, [place, limit]);
  if (!rows.length) return null;
  return (
    <div data-testid={`sponsored-vendors-${place}`}>
      <div className="flex items-end gap-3 mb-4"><div className="flex-1"><p className={`text-[11px] uppercase tracking-[0.25em] flex items-center gap-1.5 ${dark ? "text-[#C9A25A]" : "text-[#A38243]"}`}><Megaphone className="w-3.5 h-3.5" />Sponsored</p>
        <h2 className="font-serif text-3xl md:text-4xl">{title}</h2></div><Link to="/hub?tab=vendors" className="text-sm underline" data-testid={`sponsored-vendors-${place}-all`}>See all vendors</Link></div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">{rows.map((v, i) => <VendorCard key={v.page_id} v={v} i={i} />)}</div>
    </div>
  );
}
